/**
 * Shared by the Telephony page (Telephony.tsx) and the agent form's phone
 * numbers section (AgentEdit.tsx) — the same split tool-form.ts and
 * webhook-form.ts serve for their pages.
 */
import { ApiError } from '@/api'

/** The telephony error codes these screens can provoke, as sentences with a
 *  next action. Anything else is the server's own message, verbatim. */
export function telephonyMessageFor(e: unknown): string {
  if (!(e instanceof ApiError)) return e instanceof Error ? e.message : String(e)
  switch (e.code) {
    case 'read_only':
      return 'Your role can read this but not change it.'
    case 'admin_only':
      return 'Twilio credentials are admin-managed — only an admin may change them.'
    case 'no_credentials':
      return 'Twilio credentials are not configured yet — save an Account SID and auth token first.'
    case 'twilio_auth_failed':
      return 'Twilio rejected these credentials — check the SID/token pair.'
    case 'twilio_error':
      return `Twilio refused the request: ${e.message}`
    case 'no_such_number':
      return 'No number has that sid. It may have been removed — sync from Twilio and look again.'
    case 'number_released':
      return 'That number has been released; a released number cannot be changed.'
    case 'bad_agent':
      return 'That agent id was refused — the agent may no longer exist. Reload and retry.'
    case 'no_public_origin':
      return `The server has no public origin configured, so it cannot build a webhook URL: ${e.message}`
    case 'bad_field':
      return `The server refused a field: ${e.message}`
    default:
      return e.message
  }
}
